import css from "styled-jsx/css";

export const componentStyles = css.global`
  .monday-products-homepage-first-fold-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    .signup-button-wrapper {
      button.signup-button {
        background-image: var(--background);
      }

      &.card-selected {
        animation: breatheOut 0.3s linear;
        animation-delay: 0.1s;
      }
    }
  }

  @keyframes breatheOut {
    0% {
      transform: scale(1);
    }

    15% {
      transform: scale(1.01);
    }

    20% {
      transform: scale(1.02);
    }

    25% {
      transform: scale(1.03);
    }

    32% {
      transform: scale(1.04);
    }

    50% {
      transform: scale(1.05);
    }

    68% {
      transform: scale(1.04);
    }

    75% {
      transform: scale(1.03);
    }

    80% {
      transform: scale(1.02);
    }

    85% {
      transform: scale(1.01);
    }

    100% {
      transform: scale(1);
    }
  }
`;
